import { render, staticRenderFns } from "./BillsToReceive.vue?vue&type=template&id=2efa73f0&scoped=true&"
import script from "./BillsToReceive.vue?vue&type=script&lang=js&"
export * from "./BillsToReceive.vue?vue&type=script&lang=js&"
import style0 from "./BillsToReceive.vue?vue&type=style&index=0&id=2efa73f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa73f0",
  null
  
)

export default component.exports